import repository from './repository';
import axios from 'axios';

const API = process.env.VUE_APP_API_URL;

let WebhookRepository = repository('/webhooks');

WebhookRepository.getIndexData = () => {
    return axios.get(API + '/webhooks/index_data');
};

WebhookRepository.blankWebhook = () => {
    return {
        name: '',
        path: '',
        active: true,
        project_id: '',
        event_name: '',
        notesAndDescription: '',
    }
};

const CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
WebhookRepository.generateRandomPath = (length) => {
    let result = '';
    let charactersLength = CHARACTERS.length;
    for (let i = 0; i < length; i++) {
        result += CHARACTERS.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

WebhookRepository.validate = {
    name(n) {
        return (n.length >= process.env.VUE_APP_VALIDATION_WEBHOOK_MIN_NAME_LENGTH && n.length <= 255);
    },
    project(p) {
        return p > 0;
    },
    event(e) {
        return e.length >= 2;
    },
    path(p) {
        return p.length >= process.env.VUE_APP_VALIDATION_WEBHOOK_MIN_PATH_LENGTH && p.length <= 255;
    }
};

export default WebhookRepository;
